<template>
  <div class="page-wrap">

    <!-- Full-screen report overlay -->
    <div class="report-overlay" v-if="generateReport">
      <div class="report-overlay-inner">
        <i class="fa fa-spinner fa-spin"></i>
        <span v-html="loadingMessage"></span>
      </div>
    </div>

    <!-- Modals -->
    <enrollmentDetailModal
      :key="key"
      v-if="enrollmentDetailModalShow"
      v-on:closemodal="closeEnrollmentModal"
      :loading-data="loadingData"
      :has-data="hasData"
      :is_archival="true"
      :display-logs="displayLogs"
      v-on:refreshtable="refreshTable"
      :show-modal="enrollmentDetailModalShow"
      :enrollment-data="enrollmentData"
      :index-num="currentIndex"
      @reLoadTable="reTableReload"
    />
    <appointmentDetailModal
      :key="key"
      v-if="appointmentDetailModalShow"
      v-on:closemodal="closeModal"
      v-on:updatepaymentstatus="updatepaymentstatus"
      :loading-data="loadingData"
      :has-data="hasData"
      :show-modal="appointmentDetailModalShow"
      :appointment-data="appointmentData"
      :index-num="currentIndex"
      :show-qr-code="showQrCode"
      :is_archival="true"
      :token="token"
      @reLoadTable="reTableReload"
    />
    <assignarchival
      :key="key"
      v-if="AssignModalShow"
      v-on:closemodal="closeAssignModal"
      :loading-data="loadingData"
      :show-modal="AssignModalShow"
      :archivalData="archivalData"
      :index-num="currentIndex"
    />

    <canvas id="barcode" class="d-none" style="width:inherit;height:95px;"></canvas>

    <div class="panel-card" v-if="AppType">

      <!-- Header -->
      <div class="panel-header">
        <div class="panel-header-left">
          <div class="panel-icon"><i class="fa fa-archive"></i></div>
          <div>
            <div class="panel-title">
              Archival List
              <span class="count-badge" v-if="pagination.total_records > 0">{{ pagination.total_records }}</span>
            </div>
            <div class="panel-sub">Archived enrollment records</div>
          </div>
        </div>
        <div class="panel-header-right">
          <download-excel
            v-if="appoinments.length > 0"
            class="btn-export"
            :fetch="fetchData"
            :header="header"
            :worksheet="todays_date"
            name="archive-report.xls"
            :fields="json_fields"
            :before-generate="startDownload"
            :before-finish="finishDownload"
          >
            <i class="fa fa-file-excel"></i> Export Excel
          </download-excel>
        </div>
      </div>

      <!-- Toolbar -->
      <div class="toolbar">

        <!-- Search -->
        <div class="search-box">
          <i class="fa fa-search"></i>
          <input type="text" placeholder="Search by ENR, TCN, name, App No…"
            v-model="search_text" @keypress.enter="search()" />
          <button v-if="search_text" class="search-clear" @click="search_text = ''; search()">
            <i class="fa fa-times"></i>
          </button>
        </div>

        <!-- Location (type-and-select, non-client) -->
        <div class="ts-wrap" v-if="!currentUser.u.is_client" ref="locWrap" v-click-outside="closeLocDropdown">
          <div class="ts-input" @click="toggleLoc">
            <span class="ts-val" v-if="!locOpen">{{ locLabel }}</span>
            <input v-if="locOpen" type="text" class="ts-search" v-model="locSearch"
              placeholder="Search location…" ref="locInput" @keydown.esc="closeLocDropdown" />
            <i class="fa fa-chevron-down ts-arrow" :class="{ open: locOpen }"></i>
          </div>
          <div class="ts-dropdown" v-if="locOpen" :style="locDropStyle">
            <div class="ts-item" @click="selectLoc('all')">All Locations</div>
            <div class="ts-item" v-for="(c, i) in filteredLoc" :key="i" @click="selectLoc(c.id)">{{ c.name }}</div>
            <div class="ts-empty" v-if="filteredLoc.length === 0 && locSearch">No match</div>
          </div>
        </div>

        <!-- Service -->
        <select class="filter-select" v-model="service">
          <option value="all">All Services</option>
          <option v-for="(c, i) in getServices" :key="i" :value="c.id">{{ c.name }}</option>
        </select>

        <!-- Company (non-client) -->
        <select class="filter-select" v-if="!currentUser.u.is_client" v-model="company">
          <option value="all">All Companies</option>
          <option v-for="(c, i) in filteredCompanies" :key="i" :value="c.id">{{ c.company_name }}</option>
        </select>

        <!-- Date range (only when no company filter) -->
        <template v-if="company === 'all'">
          <input type="date" class="filter-date" v-model="date_from" />
          <input type="date" class="filter-date" v-model="date_to" />
        </template>

        <!-- Archival period -->
        <select class="filter-select" v-model="archival_period">
          <option value="all">All Archival</option>
          <option v-for="(c, i) in getArchivals" :key="i" :value="c.id">{{ c.name }}</option>
        </select>

        <button class="btn-search" @click="advSearch()">
          <i class="fa fa-search"></i> Search
        </button>

      </div>

      <!-- Loading -->
      <div class="state-box" v-if="getLoadingData">
        <i class="fa fa-spinner fa-spin"></i>
        Loading archived records…
      </div>

      <!-- Empty -->
      <div class="state-box" v-else-if="appoinments.length === 0">
        <i class="fa fa-archive"></i>
        No archived enrollments found
      </div>

      <!-- Table -->
      <div class="table-wrap" v-else>
        <table class="arch-table">
          <thead>
            <tr>
              <th style="width:40px;">#</th>
              <th style="min-width:100px;">Archived Date</th>
              <th style="min-width:80px;">App No.</th>
              <th style="min-width:80px;">ENR No.</th>
              <th style="min-width:130px;">Applicant</th>
              <th style="min-width:120px;">TCN</th>
              <th style="min-width:120px;">Company</th>
              <th style="min-width:160px;">Service / Location</th>
              <th style="min-width:110px;">Archival</th>
              <th style="min-width:100px;">Expires On</th>
              <th style="width:54px; text-align:right;">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in appoinments" :key="index">
              <td class="col-num">{{ (pagination.current_page - 1) * 15 + index + 1 }}</td>

              <td class="col-date">
                <span v-if="item.archival_start_date">{{ dateFormatMethod(item.archival_start_date) }}</span>
                <span class="col-na" v-else>—</span>
              </td>

              <td>
                <button class="btn-link" @click="openAppointmentDetail(item.id, item.token, index, true)">
                  {{ item.appointment_id }}
                </button>
              </td>

              <td>
                <button class="btn-link" v-if="item.enrollment_id"
                  @click="openEnrollmentDetail(item.enrollment_id, index)">
                  {{ item.enrollment_id }}
                </button>
                <span class="col-na" v-else>—</span>
              </td>

              <td class="col-applicant">{{ item.applicant || '—' }}</td>

              <td class="col-mono">{{ item.tcn || '—' }}</td>

              <td class="col-company">{{ item.company_name || '—' }}</td>

              <td>
                <div class="cell-service">
                  <span class="svc-name">
                    {{ item.service }}<em v-if="item.is_additional">, {{ item.is_additional }}</em>
                  </span>
                  <span class="svc-loc">{{ item.originating_location_name }}</span>
                </div>
              </td>

              <td class="col-archival">{{ item.archival_name || '—' }}</td>

              <td class="col-date">
                <span v-if="item.archival_expiry_date">{{ dateFormatMethod(item.archival_expiry_date) }}</span>
                <span v-else-if="item.expiration_date">{{ dateFormatMethod(item.expiration_date) }}</span>
                <span class="col-na" v-else>—</span>
              </td>

              <td style="text-align:right; overflow:visible;" @click.stop v-if="item.enrollment_id">
                <div class="action-wrap" :class="{ open: showActionButton === index }"
                  @click.stop="toggleMenu(index, $event)">
                  <div class="action-btn">•••</div>
                  <div class="action-menu" :style="showActionButton === index ? menuStyle : null">
                    <div class="menu-item blue" @click.stop="edit(item.enrollment_id, index)">
                      <i class="fa fa-download"></i> Retrieve
                    </div>
                    <div class="menu-item teal" @click.stop="assignEnrollmentCompany(item.enrollment_id, index)">
                      <i class="fa fa-building"></i> Assign Company
                    </div>
                    <div class="menu-item orange"
                      @click.stop="changeEnrollmentArchive(item.client_slug, item.enrollment_id, item.tcn, false)">
                      <i class="fa fa-sync-alt"></i> Renew Archival
                    </div>
                    <template v-if="item.enrollment_id && item.has_invoice">
                      <div class="menu-item divider"></div>
                      <div class="menu-item purple" @click.stop="openInvoice(item.enrollment_id)">
                        <i class="fa fa-file-invoice"></i> Invoice
                      </div>
                    </template>
                    <div class="menu-item divider"></div>
                    <div class="menu-item danger" @click.stop="removeArchival(item.enrollment_id, item.tcn)">
                      <i class="fa fa-trash"></i> Remove Archive
                    </div>
                  </div>
                </div>
              </td>
              <td v-else style="text-align:right;"></td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Pagination -->
      <div class="pagination-bar" v-if="pagination.total_page > 1 && !getLoadingData">
        <span class="pg-info">
          Page {{ pagination.current_page }} of {{ pagination.total_page }}
          · {{ pagination.total_records }} records
        </span>
        <div class="pg-controls">
          <button class="pg-btn" :disabled="pagination.current_page === 1" @click="firstPage()">
            <i class="fa fa-angle-double-left"></i>
          </button>
          <button class="pg-btn" :disabled="pagination.current_page === 1" @click="previousPage()">
            <i class="fa fa-angle-left"></i>
          </button>
          <button v-for="p in visiblePages" :key="p" class="pg-btn"
            :class="{ active: p === pagination.current_page }" @click="selectedPage(p)">{{ p }}</button>
          <button class="pg-btn" :disabled="pagination.current_page === pagination.total_page" @click="nextPage()">
            <i class="fa fa-angle-right"></i>
          </button>
          <button class="pg-btn" :disabled="pagination.current_page === pagination.total_page" @click="lastPage()">
            <i class="fa fa-angle-double-right"></i>
          </button>
        </div>
      </div>

    </div>

    <!-- Remove Archive Confirmation Modal -->
    <div class="del-overlay" v-if="removeModal.show" @click.self="removeModal.show = false">
      <div class="del-card">
        <div class="del-head">
          <div class="del-icon"><i class="fa fa-box-open"></i></div>
          <div class="del-title">Remove from Archive</div>
        </div>
        <div class="del-body">
          <p class="del-msg">
            You are about to remove<br />
            <strong>Enrollment #{{ removeModal.enrollment_id }}</strong> from archive.
          </p>
          <div class="del-detail" v-if="removeModal.tcn">
            <i class="fa fa-fingerprint"></i> TCN: <span>{{ removeModal.tcn }}</span>
          </div>
          <div class="del-warn">
            <i class="fa fa-exclamation-circle"></i>
            This record will no longer be archived
          </div>
        </div>
        <div class="del-foot">
          <button class="btn-del-cancel" @click="removeModal.show = false" :disabled="removeModal.removing">
            <i class="fa fa-times"></i> Cancel
          </button>
          <button class="btn-del-confirm" @click="confirmRemoveArchival()" :disabled="removeModal.removing">
            <i :class="removeModal.removing ? 'fa fa-spinner fa-spin' : 'fa fa-box-open'"></i>
            {{ removeModal.removing ? 'Removing…' : 'Remove Archive' }}
          </button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import moment from "moment";
import {
  FETCH_CLIENT_ARCHIVAL_APPOINTMENT,
  FETCH_CLIENTS,
  FETCH_SERVICES,
  UPDATE_APPOINTMENT_STATUS,
  FETCH_SELF_APPOINMENT,
  APPOINTMENT_LOGS,
  FETCH_ARCHIVALS,
  FETCH_ENROLLMENT,
  ENROLLMENT_LOGS,
  FETCH_ARCHIVAL_ENROLLMENT,
  FETCH_MASTER_COMPANIES,
  DOWNLOAD_CLIENT_ARCHIVAL_APPOINTMENT
} from "@/core/services/store/actions.type";
import { SET_BREADCRUMB } from "@/core/services/store/mutations.type";
import { mapGetters } from "vuex";
import enrollmentDetailModal from "@/components/frontend/modal/enrollmentdetail";
import * as PDF417 from "pdf417-generator";
import appointmentDetailModal from "@/components/frontend/modal/appointmentdetail";
import assignarchival from "@/pages/backend/appointment/archival/assignarchivalmodal";
import { REMOVE_ARCHIVE } from "../../../../../core/services/store/actions.type";
import JsonExcel from "vue-json-excel";

export default {
  components: {
    enrollmentDetailModal,
    appointmentDetailModal,
    assignarchival,
    downloadExcel: JsonExcel
  },
  directives: {
    clickOutside: {
      bind(el, binding) {
        el._clickOutsideHandler = e => { if (!el.contains(e.target)) binding.value(e); };
        document.addEventListener("mousedown", el._clickOutsideHandler);
      },
      unbind(el) {
        document.removeEventListener("mousedown", el._clickOutsideHandler);
      }
    }
  },
  props: {
    AppType: { type: Boolean, default: true },
    DashType: { type: String, default: "appointment_list" }
  },
  computed: {
    ...mapGetters(["currentUser", "getClients", "getServices", "getArchivals", "getMasterCompanies"]),
    filteredCompanies() {
      return (this.getMasterCompanies || []).filter(item => item.use_in_archive);
    },
    filteredLoc() {
      const q = (this.locSearch || "").toLowerCase();
      const list = this.getClients || [];
      return q ? list.filter(c => c.name && c.name.toLowerCase().includes(q)) : list;
    },
    locLabel() {
      if (this.serviceOutlet === "all" || this.serviceOutlet === "self") return "All Locations";
      const c = (this.getClients || []).find(c => c.id === this.serviceOutlet);
      return c ? c.name : "All Locations";
    },
    visiblePages() {
      const pages = [];
      const cur = this.pagination.current_page;
      const total = this.pagination.total_page;
      for (let i = Math.max(1, cur - 2); i <= Math.min(total, cur + 2); i++) pages.push(i);
      return pages;
    }
  },
  filters: {
    toFixedTwoDigit(amount) { return parseFloat(amount).toFixed(2); },
    timeFormat(value, date) {
      if (!date) return "";
      return moment(date + " " + value).format("hh:mm a");
    },
    dateFormat(date) {
      if (!date) return "";
      return moment(date).format("MM/DD/YYYY");
    }
  },
  data() {
    return {
      enrollmentData: {},
      search_text: "",
      todays_date: this.$moment(new Date()).format("MM-DD-YYYY"),
      generateReport: false,
      loadingMessage: "",
      header: ["Archive Report"],
      enrollmentDetailModalShow: false,
      AssignModalShow: false,
      appointmentDetailModalShow: false,
      enrollmentid: 0,
      locOpen: false, locSearch: "", locDropStyle: {},
      showActionButton: "",
      menuStyle: null,
      removeModal: { show: false, enrollment_id: null, tcn: "", removing: false },
      json_fields: {
        "Archived Date": {
          field: "archival_start_date",
          callback: value => value ? moment(value).format("MM/DD/YYYY") : ""
        },
        "Appointment No": "appointment_id",
        "Enrollment No": "enrollment_id",
        Applicant: "applicant",
        Location: "originating_location_name",
        Service: "service",
        TCN: "tcn",
        Company: "company_name",
        Archival: "archival_name",
        "Expires on": {
          field: "archival_expiry_date",
          callback: value => value ? moment(value).format("MM/DD/YYYY") : ""
        }
      },
      json_meta: [[{ key: "charset", value: "utf-8" }]],
      showQrCode: false,
      getLoadingData: false,
      breadCrumbs: [
        { id: 1, title: "Dashboard", route: "client.dashboard" },
        { id: 2, title: "Archival List", route: "" }
      ],
      service: "all",
      serviceOutlet: "all",
      company: "all",
      archival_period: "all",
      status: "all",
      payment_status: "all",
      date_from: this.$moment(new Date()).format("YYYY-MM-DD"),
      date_to: this.$moment(new Date()).add(7, "days").format("YYYY-MM-DD"),
      appoinments: [],
      pagination: {
        total_records: 0,
        total_page: 0,
        current_page: 1,
        per_page_data: 15,
        received_per_page_data: 15
      },
      selectedAppId: 0,
      appointmentData: {},
      archivalData: {},
      currentIndex: -1,
      loadingData: false,
      hasData: false,
      displayLogs: false,
      msg: "",
      token: "",
      key: 0
    };
  },
  mounted() {
    this.$store.dispatch(FETCH_MASTER_COMPANIES, "all");
    if (window.localStorage.getItem("appoitmentsearch") != null) {
      let search = JSON.parse(window.localStorage.getItem("appoitmentsearch"));
      this.service = search.service;
      this.status = search.status;
      this.payment_status = search.payment_status;
      this.serviceOutlet = search.service_outlet || "all";
      this.date_from = search.date_from || this.$moment(new Date()).format("YYYY-MM-DD");
      this.date_to = search.date_to || this.$moment(new Date()).add(7, "days").format("YYYY-MM-DD");
      this.type = search.currentUser;
      this.$store.dispatch(FETCH_SERVICES, this.serviceOutlet);
      this.$store.dispatch(FETCH_ARCHIVALS, this.serviceOutlet);
    } else {
      this.serviceOutlet = this.currentUser.u.is_client ? "self" : "all";
      this.$store.dispatch(FETCH_SERVICES, this.serviceOutlet);
      this.$store.dispatch(FETCH_ARCHIVALS, this.serviceOutlet);
    }
    this.loadClients();
    if (this.AppType) this.$store.commit(SET_BREADCRUMB, this.breadCrumbs);
    this.appData();
    document.addEventListener("click", this.handleDocumentClick);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleDocumentClick);
  },
  methods: {
    dateFormatMethod(date) {
      if (!date) return "";
      return moment(date).format("MM/DD/YYYY");
    },
    /* ── Type-and-select ── */
    toggleLoc() {
      this.locOpen = !this.locOpen;
      if (this.locOpen) {
        this.locSearch = "";
        this.$nextTick(() => {
          if (this.$refs.locInput) this.$refs.locInput.focus();
          const wrap = this.$refs.locWrap;
          if (wrap) {
            const r = wrap.getBoundingClientRect();
            this.locDropStyle = { position: "fixed", top: (r.bottom + 4) + "px", left: r.left + "px", width: r.width + "px", zIndex: 9999 };
          }
        });
      }
    },
    closeLocDropdown() { this.locOpen = false; this.locSearch = ""; this.locDropStyle = {}; },
    selectLoc(id) {
      this.serviceOutlet = id;
      this.closeLocDropdown();
      this.loadServices();
    },
    /* ── Action menu ── */
    toggleMenu(index, event) {
      if (this.showActionButton === index) {
        this.showActionButton = "";
        this.menuStyle = null;
        return;
      }
      this.showActionButton = index;
      this.$nextTick(() => {
        const rect = event.currentTarget.getBoundingClientRect();
        const menuH = 180;
        const rightOffset = window.innerWidth - rect.right;
        if (window.innerHeight - rect.bottom < menuH + 8) {
          this.menuStyle = { position: "fixed", bottom: (window.innerHeight - rect.top + 4) + "px", top: "auto", right: rightOffset + "px" };
        } else {
          this.menuStyle = { position: "fixed", top: (rect.bottom + 4) + "px", bottom: "auto", right: rightOffset + "px" };
        }
      });
    },
    handleDocumentClick(event) {
      if (!event.target.closest(".action-wrap")) {
        this.showActionButton = "";
        this.menuStyle = null;
      }
    },
    IndexClick(index) {
      if (this.showActionButton === index) {
        this.showActionButton = "";
      } else {
        this.showActionButton = index;
      }
    },
    /* ── Data ── */
    removeArchival(enrollment_id, tcn) {
      this.showActionButton = "";
      this.menuStyle = null;
      this.removeModal = { show: true, enrollment_id, tcn, removing: false };
    },
    confirmRemoveArchival() {
      this.removeModal.removing = true;
      this.$store.dispatch(REMOVE_ARCHIVE, { enrollment_id: this.removeModal.enrollment_id })
        .then(res => {
          this.removeModal = { show: false, enrollment_id: null, tcn: "", removing: false };
          if (res.code == 200) { this.$toastr.s(res.msg); this.refreshData(); }
        })
        .catch(errs => {
          this.removeModal.removing = false;
          this.$toastr.e(errs.error);
        });
    },
    refreshTable(index, company_name) { this.appoinments[index].company_name = company_name; },
    search() {
      this.pagination = { total_records: 0, total_page: 0, current_page: 1, per_page_data: 15, received_per_page_data: 15 };
      this.appData();
    },
    reTableReload(index) { this.appoinments[index].payment_status = "Refund"; },
    advSearch() { this.search_text = ""; this.search(); },
    openInvoice(enrollment_id) {
      this.showActionButton = "";
      this.menuStyle = null;
      this.$router.push({ name: "client.enrollment.invoice.details", params: { slug: this.$route.params.client_slug, enrollment_id } });
    },
    updatepaymentstatus(i, ps, is_drug_testing) {
      if (is_drug_testing) this.refreshData();
      this.appoinments[i].payment_status = ps;
    },
    closeModal() { this.appointmentDetailModalShow = false; },
    closeEnrollmentModal() { this.enrollmentDetailModalShow = false; },
    async loadClients() { await this.$store.dispatch(FETCH_CLIENTS); },
    closeAssignModal() { this.AssignModalShow = false; this.appData(); },
    async fetchData() {
      this.header = ["Archive Report"];
      this.header.push("Date: " + this.date_from + " to " + this.date_to);
      const loc = this.serviceOutlet !== "all" ? (this.getClients.find(c => c.id === this.serviceOutlet) || {}).name : "All";
      this.header.push("Location: " + loc);
      const svc = this.service !== "all" ? (this.getServices.find(c => c.id === this.service) || {}).name : "All";
      this.header.push("Service: " + svc);
      const cmp = this.company !== "all" ? (this.filteredCompanies.find(c => c.id === this.company) || {}).company_name : "All";
      this.header.push("Company: " + cmp);
      const arc = this.archival_period !== "all" ? (this.getArchivals.find(c => c.id === this.archival_period) || {}).name : "All";
      this.header.push("Archive: " + arc);
      const res = await this.$store.dispatch(DOWNLOAD_CLIENT_ARCHIVAL_APPOINTMENT, {
        search_text: this.search_text, service: this.service, service_outlet: this.serviceOutlet,
        date_from: this.date_from, date_to: this.date_to, archival_period: this.archival_period,
        type: this.currentUser.u.is_client ? "c" : "sp", page: this.pagination.current_page, company: this.company
      });
      return res.data;
    },
    openAppointmentDetail(appId, token, index, showQrCode) {
      const now = moment(new Date());
      const appt = this.appoinments[index];
      const appointment_date = moment(appt.schedule_date + " " + appt.start_time);
      if (appt.cancel == 1 && this.currentUser.u.is_client) return;
      if ((now.diff(appointment_date, "hours") >= 24 && this.currentUser.u.is_client) ||
        (this.currentUser.u.is_client && appt.is_locked == 1)) return;
      this.showQrCode = showQrCode;
      this.currentIndex = index;
      this.appointmentDetailModalShow = true;
      this.selectedAppId = appId;
      this.loadingData = true;
      this.$store.dispatch(FETCH_SELF_APPOINMENT, { token, appointment_id: appId })
        .then(res => {
          this.appointmentData = res.data;
          this.token = token;
          this.loadingData = false;
          this.hasData = res.hasData;
          this.key += 1;
          if (showQrCode) {
            const DBB = this.$moment(res.data.dob).format("MMDDYYYY");
            const DBC = res.data.gender == "Female" ? 2 : 1;
            const DAU = ((res.data.height * 12) / 100).toFixed(2);
            const value = "@\n\nANSI 636020090102DL00410279ZC03200010DLDAQ171774992\nDCA\nDCB\nDCD\nDBA\nDCS" +
              res.data.lname + "\nDAC" + res.data.fname + "\nDAD" + res.data.mname +
              "\nDBD\nDBB" + DBB + "\nDBC" + DBC + "\nDAY" + res.data.eye_color +
              "\nDAU0" + DAU * 100 + " in\nDAG\nDAI" + res.data.city +
              "\nDAJ" + res.data.address + "\nDAK" + res.data.zipcode + "\nDAQ\nDCF\nDCG\nDDE\nDDF\nDDG";
            const canvas = document.getElementById("barcode");
            PDF417.draw(value, canvas);
            res.data.barcode_base64 = canvas.toDataURL("image/png");
          }
          this.appointmentData = res.data;
          this.$store.dispatch(APPOINTMENT_LOGS, { app_id: appId });
        })
        .catch(() => { this.loadingData = false; });
    },
    refreshData() {
      this.pagination = { total_records: 0, total_page: 0, current_page: 1, per_page_data: 15, received_per_page_data: 15 };
      this.appData();
    },
    changeEnrollmentArchive(client_slug, enroll_id, tcn, onsite) {
      this.$router.push({ name: "client.changearchive.enrollment", params: { client_slug, enroll_id, tcn, onsite } });
    },
    closeChangeStatusFlag(index) {
      this.selectedAppId = 0;
      this.appoinments[index].change_status_flag = false;
    },
    storeStatusChange(appId, appt_status, index, status) {
      this.$store.dispatch(UPDATE_APPOINTMENT_STATUS, { app_id: appId, appt_status })
        .then(res => {
          this.$toastr.s(res.msg);
          this.appoinments[index].appt_status = status;
          if (status == "Cancel") { this.appoinments[index].cancel = 1; }
          else { this.appoinments[index].cancel = 0; }
          this.closeChangeStatusFlag(index);
        })
        .catch(err => { this.$toastr.e(err.msg); });
    },
    openEnrollmentDetail(enrollmentId, index) {
      this.currentIndex = index;
      this.enrollmentDetailModalShow = true;
      this.selectedAppId = enrollmentId;
      this.loadingData = true;
      this.$store.dispatch(ENROLLMENT_LOGS, { enrollment_id: enrollmentId });
      this.$store.dispatch(FETCH_ENROLLMENT, { enrollment_id: enrollmentId })
        .then(res => {
          this.displayLogs = true;
          this.enrollmentData = res.data;
          this.loadingData = false;
          this.hasData = res.hasData;
          this.key += 1;
        })
        .catch(() => { this.loadingData = false; });
    },
    assignEnrollmentCompany(enrollmentId, index) {
      this.currentIndex = index;
      this.enrollmentDetailModalShow = true;
      this.selectedAppId = enrollmentId;
      this.loadingData = true;
      this.$store.dispatch(ENROLLMENT_LOGS, { enrollment_id: enrollmentId });
      this.$store.dispatch(FETCH_ENROLLMENT, { enrollment_id: enrollmentId })
        .then(res => {
          this.displayLogs = false;
          this.enrollmentData = res.data;
          this.loadingData = false;
          this.hasData = res.hasData;
          this.key += 1;
        })
        .catch(() => { this.loadingData = false; });
    },
    edit(enrollmentId, index) {
      this.$store.dispatch(FETCH_ARCHIVAL_ENROLLMENT, { enrollment_id: enrollmentId })
        .then(res => {
          this.currentIndex = index;
          this.AssignModalShow = true;
          this.archivalData = res.data;
          this.loadingData = false;
          this.hasData = res.hasData;
          this.key += 1;
        })
        .catch(() => { this.loadingData = false; });
    },
    selectedPage(n) { this.pagination.current_page = n; this.appData(); },
    nextPage()     { this.pagination.current_page++; this.appData(); },
    lastPage()     { this.pagination.current_page = this.pagination.total_page; this.appData(); },
    firstPage()    { this.pagination.current_page = 1; this.appData(); },
    previousPage() { this.pagination.current_page--; this.appData(); },
    loadServices() {
      this.service = "all";
      this.archival_period = "all";
      if (this.currentUser.u.is_admin == 1) {
        this.$store.dispatch(FETCH_MASTER_COMPANIES, this.serviceOutlet);
        this.$store.dispatch(FETCH_SERVICES, { sp: this.serviceOutlet, location: "all" });
      } else {
        this.$store.dispatch(FETCH_SERVICES, this.serviceOutlet);
      }
      this.$store.dispatch(FETCH_ARCHIVALS, this.serviceOutlet);
    },
    startDownload() { this.generateReport = true; this.loadingMessage = "please wait <br> Your report is being generated..."; },
    finishDownload() { this.generateReport = false; this.loadingMessage = ""; },
    appData() {
      this.appoinments = [];
      this.getLoadingData = true;
      const data_ = {
        search_text: this.search_text, service: this.service, service_outlet: this.serviceOutlet,
        date_from: this.date_from, date_to: this.date_to, archival_period: this.archival_period,
        type: this.currentUser.u.is_client ? "c" : "sp", page: this.pagination.current_page, company: this.company
      };
      const data = {
        service: this.service, service_outlet: this.serviceOutlet, date_from: this.date_from,
        date_to: this.date_to, type: this.currentUser.u.is_client ? "c" : "sp",
        status: this.status, payment_status: this.payment_status,
        page: this.pagination.current_page, search_text: this.search_text, dtype: "appointment_list"
      };
      window.localStorage.setItem("appoitmentsearch", JSON.stringify(data));
      this.$store.dispatch(FETCH_CLIENT_ARCHIVAL_APPOINTMENT, data_)
        .then(res => {
          this.getLoadingData = false;
          this.appoinments = res.data;
          this.pagination.total_records = res.total_record;
          this.pagination.total_page = res.page_range;
          this.pagination.received_per_page_data = res.data.length;
          this.pagination.per_page_data = this.DashType == "appointment_list" ? 15 : 8;
        })
        .catch(err => { this.getLoadingData = false; this.msg = err.error; });
    }
  }
};
</script>

<style lang="scss" scoped>
$font: 'Segoe UI', sans-serif;
$blue: #389ad4;
$dark: #0d1b3e;
$border: #dde2ec;

.page-wrap {
  padding: 8px 0 80px;
  font-family: $font;
}

/* ── Report overlay ── */
.report-overlay {
  position: fixed;
  inset: 0;
  background: rgba(5, 13, 36, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  backdrop-filter: blur(3px);
}

.report-overlay-inner {
  background: #fff;
  border-radius: 12px;
  padding: 28px 36px;
  display: flex;
  align-items: center;
  gap: 14px;
  font-size: 15px;
  font-family: $font;
  color: $dark;
  box-shadow: 0 16px 48px rgba(5,13,36,0.2);

  i { font-size: 22px; color: $blue; }
}

/* ── Panel ── */
.panel-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(13, 27, 62, 0.07);
  overflow: visible;
}

/* ── Header ── */
.panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 20px;
  background: #fafbfd;
  border-bottom: 1px solid #eef0f6;
  gap: 10px;
  flex-wrap: wrap;
}

.panel-header-left { display: flex; align-items: center; gap: 12px; }

.panel-icon {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: $blue;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  flex-shrink: 0;
}

.panel-title {
  font-size: 14px;
  font-weight: 700;
  color: $dark;
  display: flex;
  align-items: center;
  gap: 8px;
}

.count-badge {
  font-size: 11px;
  font-weight: 600;
  color: #7a8499;
  background: #eef0f6;
  border-radius: 10px;
  padding: 1px 7px;
}

.panel-sub { font-size: 11px; color: #8a94a6; margin-top: 2px; }

.btn-export {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 34px;
  padding: 0 14px;
  border-radius: 7px;
  border: 1.5px solid #b7dba1;
  background: #f0fdf4;
  color: #276749;
  font-size: 12px;
  font-weight: 600;
  font-family: $font;
  cursor: pointer;
  text-decoration: none;
  transition: all 0.15s;

  &:hover { background: #dcfce7; border-color: #86efac; }
  i { font-size: 13px; }
}

/* ── Toolbar ── */
.toolbar {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 20px;
  border-bottom: 1px solid #f0f3fa;
  flex-wrap: wrap;
}

.search-box {
  position: relative;
  flex: 1;
  min-width: 200px;
  max-width: 320px;

  i { position: absolute; left: 10px; top: 50%; transform: translateY(-50%); color: #a0aab8; font-size: 12px; pointer-events: none; }

  input {
    width: 100%;
    height: 36px;
    border: 1.5px solid $border;
    border-radius: 8px;
    padding: 0 30px 0 30px;
    font-size: 13px;
    font-family: $font;
    color: $dark;
    outline: none;
    transition: border-color 0.2s;

    &::placeholder { color: #b0bac9; }
    &:focus { border-color: $blue; box-shadow: 0 0 0 3px rgba(56,154,212,0.1); }
  }
}

.search-clear {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  border: none;
  background: transparent;
  color: #a0aab8;
  cursor: pointer;
  font-size: 11px;
  padding: 0;
  &:hover { color: $dark; }
}

/* ── Type-and-select ── */
.ts-wrap {
  position: relative;
  min-width: 180px;
  max-width: 240px;
}

.ts-input {
  display: flex;
  align-items: center;
  height: 36px;
  border: 1.5px solid $border;
  border-radius: 8px;
  padding: 0 10px;
  background: #fff;
  cursor: pointer;
  gap: 6px;
  transition: border-color 0.2s;

  &:hover { border-color: $blue; }
  &:focus-within { border-color: $blue; box-shadow: 0 0 0 3px rgba(56,154,212,0.1); }
}

.ts-val {
  flex: 1;
  font-size: 13px;
  color: $dark;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  user-select: none;
}

.ts-search {
  flex: 1;
  border: none;
  outline: none;
  font-size: 13px;
  color: $dark;
  font-family: $font;
  background: transparent;
  min-width: 0;
  &::placeholder { color: #b0bac9; }
}

.ts-arrow {
  font-size: 10px;
  color: #a0aab8;
  flex-shrink: 0;
  transition: transform 0.2s;
  pointer-events: none;
  &.open { transform: rotate(180deg); }
}

.ts-dropdown {
  position: fixed;
  background: #fff;
  border: 1.5px solid $border;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(13, 27, 62, 0.12);
  z-index: 9999;
  max-height: 220px;
  overflow-y: auto;
}

.ts-item {
  padding: 8px 12px;
  font-size: 13px;
  color: $dark;
  font-family: $font;
  cursor: pointer;
  white-space: normal;
  word-break: break-word;
  line-height: 1.4;
  transition: background 0.12s;
  &:hover { background: #f0f7fd; color: $blue; }
}

.ts-empty { padding: 10px 12px; font-size: 12px; color: #a0aab8; text-align: center; }

.filter-select {
  height: 36px;
  border: 1.5px solid $border;
  border-radius: 8px;
  padding: 0 28px 0 10px;
  font-size: 13px;
  color: $dark;
  font-family: $font;
  background: #fff url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6'%3E%3Cpath d='M0 0l5 6 5-6z' fill='%23a0aab8'/%3E%3C/svg%3E") no-repeat right 10px center;
  appearance: none;
  outline: none;
  cursor: pointer;
  max-width: 180px;
  transition: border-color 0.2s;
  &:focus { border-color: $blue; }
}

.filter-date {
  height: 36px;
  border: 1.5px solid $border;
  border-radius: 8px;
  padding: 0 10px;
  font-size: 12px;
  font-family: $font;
  color: $dark;
  background: #fff;
  outline: none;
  &:focus { border-color: $blue; }
}

.btn-search {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 36px;
  padding: 0 16px;
  border-radius: 8px;
  border: none;
  background: $blue;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  font-family: $font;
  cursor: pointer;
  transition: opacity 0.2s;
  i { font-size: 11px; }
  &:hover { opacity: 0.9; }
}

/* ── States ── */
.state-box {
  text-align: center;
  padding: 48px 24px;
  color: #a0aab8;
  font-size: 13px;
  i { font-size: 28px; display: block; margin-bottom: 10px; opacity: 0.45; }
}

/* ── Table ── */
.table-wrap { overflow-x: auto; }

.arch-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
  font-family: $font;
  table-layout: auto;

  thead tr {
    border-bottom: 2px solid #eef0f8;

    th {
      padding: 9px 10px;
      font-size: 11px;
      font-weight: 700;
      color: #7a8499;
      text-transform: uppercase;
      letter-spacing: 0.4px;
      white-space: nowrap;
      text-align: left;
      background: #fff;
    }
  }

  tbody tr {
    border-bottom: 1px solid #f5f7fa;
    transition: background 0.15s;

    &:last-child { border-bottom: none; }
    &:hover td { background: #f8fbff; }

    td { padding: 9px 10px; color: #2d3748; vertical-align: middle; }
  }
}

.col-num   { color: #a0aab8; font-size: 12px; }
.col-date  { font-size: 12px; color: #6b7280; white-space: nowrap; }
.col-mono  { font-family: 'Courier New', monospace; font-size: 11.5px; color: #4a5568; }
.col-na    { color: #c0c9d8; }
.col-applicant { font-weight: 500; color: $dark; }
.col-company   { font-size: 12px; color: #4a5568; }
.col-archival  { font-size: 12px; color: #4a5568; }

.btn-link {
  border: none;
  background: none;
  padding: 0;
  color: $blue;
  font-size: 13px;
  font-family: $font;
  font-weight: 600;
  cursor: pointer;
  text-decoration: underline;
  text-underline-offset: 2px;
  &:hover { color: darken(#389ad4, 10%); }
}

.cell-service {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.svc-name {
  font-weight: 600;
  color: $dark;
  em { font-style: normal; font-weight: 400; color: #6b7280; }
}

.svc-loc { font-size: 11px; color: #7a8499; }

/* ── Action dropdown ── */
.action-wrap {
  position: relative;
  display: inline-block;

  .action-btn {
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    background: #f5f7fa;
    border: 1px solid #e2e8f0;
    cursor: pointer;
    font-size: 16px;
    font-weight: 700;
    color: #4a5568;
    letter-spacing: 1px;
    transition: background 0.15s;
    &:hover { background: #eef2fb; color: #185FA5; border-color: #c5d4f0; }
  }

  .action-menu {
    display: none;
    position: fixed;
    background: #fff;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    min-width: 160px;
    box-shadow: 0 8px 24px rgba(13, 27, 62, 0.12);
    z-index: 9999;
    overflow: hidden;

    .menu-item {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 9px 14px;
      font-size: 13px;
      cursor: pointer;
      transition: background 0.15s;
      i { width: 16px; font-size: 13px; }

      &.blue   { color: #185FA5;  i { color: #185FA5; }  &:hover { background: #eef2fb; } }
      &.teal   { color: #276749;  i { color: #276749; }  &:hover { background: #f0fdf4; } }
      &.orange { color: #c05621;  i { color: #c05621; }  &:hover { background: #fff7ed; } }
      &.purple { color: #6b46c1;  i { color: #6b46c1; }  &:hover { background: #f5f3ff; } }
      &.danger { color: #c62828;  i { color: #c62828; }  &:hover { background: #fff5f5; } }
      &.divider { border-top: 1px solid #f0f3fa; pointer-events: none; padding: 0; margin: 0; }
    }
  }

  &.open .action-menu { display: block; }
}

/* ── Pagination ── */
.pagination-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 20px;
  border-top: 1px solid #f0f3fa;
  flex-wrap: wrap;
  gap: 10px;
}

.pg-info { font-size: 12px; color: #7a8499; }
.pg-controls { display: flex; align-items: center; gap: 4px; }

.pg-btn {
  min-width: 32px;
  height: 32px;
  padding: 0 8px;
  border: 1.5px solid $border;
  background: #fff;
  color: #4a5568;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  font-family: $font;
  cursor: pointer;
  transition: all 0.15s;

  &:hover:not(:disabled) { border-color: $blue; color: $blue; }
  &:disabled { opacity: 0.35; cursor: default; }
  &.active { background: $blue; border-color: $blue; color: #fff; }
}

/* ── Remove Archive Modal ── */
.del-overlay {
  position: fixed;
  inset: 0;
  background: rgba(13, 27, 62, 0.52);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9200;
  backdrop-filter: blur(3px);
  padding: 20px;
  font-family: $font;
}

.del-card {
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 24px 64px rgba(13, 27, 62, 0.22);
  width: 100%;
  max-width: 400px;
  overflow: hidden;
}

.del-head {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 28px 24px 16px;
  background: #fff7ed;
  border-bottom: 1px solid #fed7aa;
}

.del-icon {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  background: #fed7aa;
  color: #c05621;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  margin-bottom: 12px;
}

.del-title {
  font-size: 15px;
  font-weight: 700;
  color: #c05621;
}

.del-body {
  padding: 20px 24px 12px;
  text-align: center;
}

.del-msg {
  font-size: 13px;
  color: #4a5568;
  line-height: 1.6;
  margin: 0 0 10px;
  strong { color: $dark; }
}

.del-detail {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #f5f7fb;
  border: 1px solid $border;
  border-radius: 6px;
  padding: 4px 12px;
  font-size: 12px;
  color: #4a5568;
  font-family: 'Courier New', monospace;
  margin-bottom: 10px;

  i { color: $blue; font-size: 11px; }
  span { font-weight: 600; }
}

.del-warn {
  font-size: 11px;
  color: #c05621;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  margin-top: 4px;
}

.del-foot {
  display: flex;
  gap: 10px;
  padding: 16px 24px 24px;

  button {
    flex: 1;
    height: 40px;
    border-radius: 8px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    font-family: $font;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    transition: all 0.15s;
  }

  .btn-del-cancel {
    background: #fff;
    color: #4a5568;
    border: 1.5px solid $border;
    &:hover:not(:disabled) { border-color: $blue; color: $blue; }
    &:disabled { opacity: 0.5; cursor: not-allowed; }
  }

  .btn-del-confirm {
    background: #c05621;
    color: #fff;
    border: none;
    &:hover:not(:disabled) { background: #9c4318; }
    &:disabled { opacity: 0.6; cursor: not-allowed; }
  }
}
</style>

<style>
.swal2-popup .swal2-icon { margin-left: 39% !important; }
</style>
